import {
  Typography,
  Box,
  Grid,
  Paper,
  FormControl,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TestModelAction,
  UpdateAIConfigAction,
} from "../../../../../store/Ancillary/AIConfig/Action";
import { toast } from "react-toastify";
import { createStyles, makeStyles } from "@mui/styles";
import SelectableSearch from "../../../Base/views/SelectableSearch";

const ApiKeyCongifuration = () => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        paddingBottom: "30px",
        borderRadius: "10px",
        backgroundColor: "#f3edfd",
        position: "relative",
      },
      Backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        position: "absolute",
        borderRadius: "inherit",
      },
    })
  );
  const dispatch = useDispatch();
  const classes = useStyles();
  const initialValue = {
    resume_processor_model_id: "",
    profile_scoring_model_id: "",
    jd_model_id: ""
  };
  const [inputData, setInputData] = useState(initialValue);
  const { AiConfigLoading, aiConfigData, ModelTestingLoading } = useSelector(
    (state) => state.AncillaryReducer?.AIConfigReducer
  );
  const [modelData, setModelData] = useState({
    load: true,
    values: [],
  });
  const [jdModelData, setJdModelData] = useState({
    load: true,
    values: [],
  });

  const handleInputChange = (event, value) => {
    if (
      ["resume_processor_model_id", "profile_scoring_model_id", "jd_model_id"].includes(event)
    ) {
      if (value) {
        if (value?.ai_token_configuration_pk) {
          const payload = {
            ...value,
            ai_token_json: value?.ai_token_json
              ? JSON.stringify(value?.ai_token_json)
              : "",
            ai_token_configuration_fk: value?.ai_token_configuration_pk,
          };
          if (event === "resume_processor_model_id") {
            payload.resume_processor_selection = true;
          } else if (event === "profile_scoring_model_id") {
            payload.profile_scoring_selection = true;
          } else if (event === "jd_model_id") {
            payload.jd_generation_selection = true;
          }
          if (payload?.ai_type !== 'Meepl Base AI') {
            dispatch(
              TestModelAction(
                {
                  apiKey: payload?.ai_token,
                  model: value?.ai_token_json?.name,
                  setting: true,
                  provider: value?.ai_token_json?.provider
                },
                (error, result) => {
                  if (!error && result?.data?.statuscode === 200) {
                    dispatch(UpdateAIConfigAction(payload));
                  } else {
                    setExistingData();
                  }
                }
              )
            );
          } else {
            dispatch(UpdateAIConfigAction(payload));
          }
        } else {
          toast.error("Something went wrong!");
        }
      }
    }
  };
  const handleLoadModel = () => {
    if (aiConfigData) {
      const sortedData = [...aiConfigData].sort((a, b) => (b?.is_default ? 1 : 0) - (a?.is_default ? 1 : 0));
      const strData = sortedData?.map((el) => {
        const rawLabel = el?.ai_token_json?.display_name || el?.ai_token_json?.name || "";
        return {
          ...el,
          label: rawLabel.replace(/^models\//, ""),
        };
      });
      setModelData({ load: false, values: strData });
      setJdModelData({ load: false, values: strData });
    }
  };
  const setExistingData = () => {
    const profileScoreSelected = aiConfigData?.find(
      (el) => el?.profile_scoring_selection === true
    );
    const resumeProcessorSelected = aiConfigData?.find(
      (el) => el?.resume_processor_selection === true
    );
    const jdSelected = aiConfigData?.find(
      (el) => el?.jd_generation_selection === true
    );

    const getCleanLabel = (item) => {
      const raw = item?.ai_token_json?.display_name || item?.ai_token_json?.name || "";
      return raw.replace(/^models\//, "");
    };

    setInputData((prev) => ({
      ...prev,
      ...(profileScoreSelected && {
        profile_scoring_model_id: {
          ...profileScoreSelected,
          label: getCleanLabel(profileScoreSelected),
        },
      }),
      ...(resumeProcessorSelected && {
        resume_processor_model_id: {
          ...resumeProcessorSelected,
          label: getCleanLabel(resumeProcessorSelected),
        },
      }),
      ...(jdSelected && {
        jd_model_id: {
          ...jdSelected,
          label: getCleanLabel(jdSelected),
        },
      }),
    }));
  }
  useEffect(() => {
    setExistingData();
    handleLoadModel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aiConfigData]);

  return (
    <Box sx={{ p: 1 }}>
      <Paper className={classes.paper}>
        <Backdrop className={classes.Backdrop} open={AiConfigLoading || ModelTestingLoading}>
          <CircularProgress />
        </Backdrop>
        <Grid container spacing={4}>
          {/* ---- Profile Scoring Section ---- */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 1, color: "#333" }}
            >
              Profile Scoring
            </Typography>
            <FormControl fullWidth>
              <SelectableSearch
                isOptionEqualToValue={(option, value) =>
                  +option.ai_token_configuration_pk ===
                  +value.ai_token_configuration_pk
                }
                label="Select Profile Scoring Model"
                value={inputData?.profile_scoring_model_id}
                loading={handleLoadModel}
                fieldLabel={"label"}
                required
                grouping={true}
                groupByFn={(option) => option.ai_type}
                variant="outlined"
                name="profile_scoring_model_id"
                size="small"
                onChangeEvent={handleInputChange}
                data={modelData}
              />
            </FormControl>
          </Grid>

          {/* ---- Resume Processor Section ---- */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 1, color: "#333" }}
            >
              Resume Processor
            </Typography>
            <FormControl fullWidth>
              <SelectableSearch
                isOptionEqualToValue={(option, value) =>
                  +option.ai_token_configuration_pk ===
                  +value.ai_token_configuration_pk
                }
                label="Select Resume Processor Model"
                value={inputData?.resume_processor_model_id}
                loading={handleLoadModel}
                fieldLabel="label"
                required
                grouping={true}
                groupByFn={(option) => option.ai_type}
                variant="outlined"
                name="resume_processor_model_id"
                size="small"
                onChangeEvent={handleInputChange}
                data={modelData}
              />
            </FormControl>
          </Grid>
          {/* ---- Job Description ---- */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 1, color: "#333" }}
            >
              ATS Job
            </Typography>
            <FormControl fullWidth>
              <SelectableSearch
                isOptionEqualToValue={(option, value) =>
                  +option.ai_token_configuration_pk ===
                  +value.ai_token_configuration_pk
                }
                label="Select ATS Job Model"
                value={inputData?.jd_model_id}
                loading={() => handleLoadModel("jd")}
                fieldLabel="label"
                required
                grouping={true}
                groupByFn={(option) => option.ai_type}
                variant="outlined"
                name="jd_model_id"
                size="small"
                onChangeEvent={handleInputChange}
                data={jdModelData}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default ApiKeyCongifuration;
